import apiClient from "./client";

export async function fetchPremiumSocial(signal) {
  const response = await apiClient.get("premium/social/", { signal });
  return response.data;
}

export async function sendFriendRequest(receiverId) {
  const response = await apiClient.post("premium/social/friends/", {
    receiver_id: receiverId,
  });
  return response.data;
}

export async function respondFriendRequest(friendshipId, action) {
  const response = await apiClient.post(
    `premium/social/friends/${friendshipId}/respond/`,
    { action }
  );
  return response.data;
}

export async function sendGameInvite({ receiverId, category, battleId, message }) {
  const response = await apiClient.post("premium/social/game-invites/", {
    receiver_id: receiverId,
    category,
    battle_id: battleId,
    message,
  });
  return response.data;
}

export async function respondGameInvite(inviteId, action) {
  const response = await apiClient.post(
    `premium/social/game-invites/${inviteId}/respond/`,
    { action }
  );
  return response.data;
}

export async function fetchPrivateMessages(userId) {
  const response = await apiClient.get("premium/social/messages/", {
    params: { user_id: userId },
  });
  return response.data;
}

export async function sendPrivateMessage({ receiverId, body }) {
  const response = await apiClient.post("premium/social/messages/", {
    receiver_id: receiverId,
    body,
  });
  return response.data;
}

export async function createTeam({ name, tag, logo }) {
  const formData = new FormData();
  formData.append("name", name);
  formData.append("tag", tag);
  if (logo) formData.append("logo", logo);

  const response = await apiClient.post("premium/social/teams/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function requestJoinTeam(teamId) {
  const response = await apiClient.post(`premium/social/teams/${teamId}/join-requests/`);
  return response.data;
}

export async function deleteTeam(teamId) {
  const response = await apiClient.delete(`premium/social/teams/${teamId}/delete/`);
  return response.data;
}

export async function kickTeamMember(teamId, userId) {
  const response = await apiClient.delete(`premium/social/teams/${teamId}/kick/${userId}/`);
  return response.data;
}

export async function inviteTeamMember({ teamId, userId }) {
  const response = await apiClient.post(`premium/social/teams/${teamId}/invitations/`, {
    user_id: userId,
  });
  return response.data;
}

export async function respondTeamRequest(requestId, action) {
  const response = await apiClient.post(`premium/social/team-requests/${requestId}/respond/`, {
    action,
  });
  return response.data;
}

export async function fetchTeamMessages(teamId, signal) {
  const response = await apiClient.get(`premium/social/teams/${teamId}/messages/`, { signal });
  return response.data;
}

export async function sendTeamMessage(teamId, text) {
  const response = await apiClient.post(`premium/social/teams/${teamId}/messages/`, { text });
  return response.data;
}

export async function updateTeam(teamId, { bio, banner, logo } = {}) {
  const formData = new FormData();
  if (bio !== undefined) formData.append("bio", bio);
  if (banner) formData.append("banner", banner);
  if (logo) formData.append("logo", logo);

  const response = await apiClient.patch(`premium/social/teams/${teamId}/update/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function leaveTeam(teamId) {
  const response = await apiClient.post(`premium/social/teams/${teamId}/leave/`);
  return response.data;
}

export async function updateProfileBackground(background) {
  const formData = new FormData();
  formData.append("background", background);

  const response = await apiClient.post("premium/social/background/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}
